var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5459 2.66126C23.144 1.50084 24.1081 1 24.9999 1C25.8918 1 26.8558 1.50084 27.454 2.66126L48.5495 43.5857C49.1738 44.7967 49.1133 46.1819 48.5887 47.2605C48.0639 48.3395 47.1435 49 46.0956 49H3.90448C2.85652 49 1.93614 48.3395 1.4113 47.2605C0.886653 46.1819 0.826214 44.7967 1.45044 43.5857L0.561585 43.1275L1.45044 43.5857L22.5459 2.66126L21.657 2.20308L22.5459 2.66126Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.f8d2ba5a8b23dff356eccad2472946c1.svg";
export { ForwardRef as ReactComponent };